
import React, { useState, useEffect } from "react";
import background from "../assets/background.webp";
import { useTranslation } from "react-i18next";

const FORM_SUBMIT_URL = "https://solarholding.am/send-mail.php";

const JobsPage = () => {
  const { t } = useTranslation();

  const jobs = [
    {
      title: t("jobs_list.0"),
      date: "30/12/2026",
      type: "Full-time",
    },
    {
      title: t("jobs_list.1"),
      date: "31/12/2026",
      type: "Full-time",
    },
  ];

  const [activeJob, setActiveJob] = useState(null);

  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState({
    type: "",
    message: "",
  });

  const [success, setSuccess] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  // Обработка изменения полей формы
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));

    if (status.type === "error") {
      setStatus({
        type: "",
        message: "",
      });
    }
  };

  // Открытие модального окна
  const openModal = (job) => {
    setActiveJob(job);

    setForm({
      name: "",
      email: "",
      message: "",
    });

    setStatus({
      type: "",
      message: "",
    });

    setSuccess(false);
    setIsSubmitting(false);
    setModalVisible(true);
  };

  // Закрытие модального окна
  const closeModal = () => {
    if (isSubmitting) return;

    setModalVisible(false);

    setTimeout(() => {
      setActiveJob(null);

      setForm({
        name: "",
        email: "",
        message: "",
      });

      setStatus({
        type: "",
        message: "",
      });

      setSuccess(false);
    }, 500);
  };

  // Отправка заявки
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    if (!activeJob) {
      setStatus({
        type: "error",
        message: t("jobs_send_error"),
      });

      return;
    }

    const name = form.name.trim();
    const email = form.email.trim();
    const message = form.message.trim();

    if (!name || !email || !message) {
      setStatus({
        type: "error",
        message: t("jobs_fill_all_fields"),
      });

      return;
    }

    // Проверка email перед отправкой
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailPattern.test(email)) {
      setStatus({
        type: "error",
        message: "Please enter a valid email address.",
      });

      return;
    }

    setIsSubmitting(true);

    setStatus({
      type: "loading",
      message: t("jobs_send_loading"),
    });

    try {
      const response = await fetch(FORM_SUBMIT_URL, {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          type: "job",
          name,
          email,
          message,
          job: activeJob.title,
        }),
      });

      // Получаем ответ PHP
      const data = await response.json();

      console.log("JOB APPLICATION RESPONSE:", {
        status: response.status,
        data,
      });

      if (!response.ok || !data.success) {
        throw new Error(
          data.message || "Failed to send application."
        );
      }

      // Успешная отправка
      setStatus({
        type: "success",
        message: t("jobs_success_title"),
      });

      setSuccess(true);

      // Закрываем окно после показа сообщения
      setTimeout(() => {
        setModalVisible(false);

        setTimeout(() => {
          setActiveJob(null);

          setForm({
            name: "",
            email: "",
            message: "",
          });

          setStatus({
            type: "",
            message: "",
          });

          setSuccess(false);
          setIsSubmitting(false);
        }, 500);
      }, 2000);
    } catch (error) {
      console.error("JOB APPLY ERROR:", error);

      setStatus({
        type: "error",
        message: t("jobs_send_error"),
      });

      setIsSubmitting(false);
    }
  };

  return (
    <section
      className="w-full min-h-screen bg-slate-800 text-white py-20 px-4 bg-cover bg-center"
      style={{
        backgroundImage: `url(${background})`,
      }}
    >
      {/* HEADER */}
      <div
        className={`text-center pt-24 mb-16 transition-all duration-1000 ${
          isVisible
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-10"
        }`}
      >
        <h1 className="text-[20px] md:text-[64px] uppercase tracking-[0.15em] font-['Cormorant_Garamond']">
          {t("jobs_page_title")}
        </h1>

        <p className="text-yellow-400 tracking-[0.4em] uppercase mt-4 text-sm">
          {t("jobs_page_subtitle")}
        </p>
      </div>

      {/* JOB LIST */}
      <div
        className={`max-w-5xl mx-auto flex flex-col gap-6 transition-all duration-1000 delay-300 ${
          isVisible
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-10"
        }`}
      >
        {jobs.map((job, i) => (
          <div
            key={i}
            className="group bg-white rounded-2xl p-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(0,0,0,0.5)]"
          >
            <div>
              <h3 className="text-xl uppercase text-black tracking-[0.1em]">
                {job.title}
              </h3>

              <p className="text-gray-500 text-sm mt-1">
                {t("jobs_apply_deadline")} {job.date}
              </p>
            </div>

            <div className="flex items-center gap-4">
              <span className="text-yellow-500 text-sm tracking-[0.2em] uppercase">
                {job.type}
              </span>

              <button
                type="button"
                onClick={() => openModal(job)}
                className="px-5 py-2 bg-yellow-400 text-black uppercase tracking-[0.2em] text-sm hover:bg-yellow-300 transition"
              >
                {t("jobs_apply_button")}
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* MODAL */}
      {activeJob && (
        <div
          className={`fixed inset-0 bg-black/70 flex items-center justify-center z-50 px-4 transition-all duration-500 ${
            modalVisible ? "opacity-100" : "opacity-0"
          }`}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closeModal();
            }
          }}
        >
          <div
            className={`bg-[#1e293b] w-full max-w-lg rounded-2xl p-6 relative transition-all duration-500 transform ${
              modalVisible
                ? "scale-100 opacity-100"
                : "scale-95 opacity-0"
            }`}
          >
            {/* CLOSE */}
            <button
              type="button"
              onClick={closeModal}
              disabled={isSubmitting}
              aria-label="Close"
              className="absolute top-3 right-4 text-white text-3xl disabled:opacity-50"
            >
              ✕
            </button>

            <h4 className="tracking-[0.1em] mb-2 text-white">
              {t("jobs_application_for")}
            </h4>

            <h2 className="text-xl uppercase tracking-[0.1em] mb-4 text-yellow-400">
              {activeJob.title}
            </h2>

            {/* SUCCESS MESSAGE */}
            {success ? (
              <div className="text-center py-10">
                <div className="text-green-400 text-xl font-bold">
                  {t("jobs_success_title")}
                </div>

                <p className="text-white/70 mt-2">
                  {t("jobs_success_subtitle")}
                </p>
              </div>
            ) : (
              <form
                onSubmit={handleSubmit}
                className="flex flex-col gap-4"
              >
                {/* NAME */}
                <input
                  type="text"
                  name="name"
                  autoComplete="name"
                  placeholder={t("jobs_name_placeholder")}
                  value={form.name}
                  onChange={handleChange}
                  maxLength={150}
                  required
                  disabled={isSubmitting}
                  className="p-3 rounded-lg bg-[#0f172a] border border-white/10 outline-none focus:border-yellow-400 disabled:opacity-60"
                />

                {/* EMAIL */}
                <input
                  type="email"
                  name="email"
                  autoComplete="email"
                  placeholder={t("jobs_email_placeholder")}
                  value={form.email}
                  onChange={handleChange}
                  maxLength={254}
                  required
                  disabled={isSubmitting}
                  className="p-3 rounded-lg bg-[#0f172a] border border-white/10 outline-none focus:border-yellow-400 disabled:opacity-60"
                />

                {/* MESSAGE */}
                <textarea
                  name="message"
                  placeholder={t("jobs_message_placeholder")}
                  rows={4}
                  value={form.message}
                  onChange={handleChange}
                  maxLength={10000}
                  required
                  disabled={isSubmitting}
                  className="p-3 rounded-lg bg-[#0f172a] border border-white/10 outline-none focus:border-yellow-400 resize-none disabled:opacity-60"
                />

                {/* SUBMIT */}
                <button
                  type="submit"
                  disabled={
                    isSubmitting ||
                    !form.name.trim() ||
                    !form.email.trim() ||
                    !form.message.trim()
                  }
                  className={`bg-yellow-400 text-black uppercase tracking-[0.2em] py-3 rounded-lg transition ${
                    isSubmitting ||
                    !form.name.trim() ||
                    !form.email.trim() ||
                    !form.message.trim()
                      ? "opacity-50 cursor-not-allowed"
                      : "hover:bg-yellow-300"
                  }`}
                >
                  {isSubmitting
                    ? t("jobs_send_loading")
                    : t("jobs_submit_button")}
                </button>

                {/* STATUS MESSAGE */}
                {status.message && (
                  <p
                    role="status"
                    aria-live="polite"
                    className={`text-sm ${
                      status.type === "success"
                        ? "text-green-400"
                        : status.type === "loading"
                        ? "text-yellow-400"
                        : "text-red-400"
                    }`}
                  >
                    {status.message}
                  </p>
                )}
              </form>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default JobsPage;

